import React from 'react';
import OATT from './OATT';

interface SSKUComponent extends React.FC {
  title?: string;

}

const SSKU: SSKUComponent = () => {
    return <OATT />;
};

SSKU.title  = 'Attachment Rate';
export default SSKU;